import axios from 'axios'
import create, { GetState, SetState } from 'zustand'
import toast from 'react-hot-toast'
import { persist } from 'zustand/middleware'
import { handleAxiosError } from '../utils/error'
import { Axios } from '../utils/axios'

type NotificationState = {
  loading: string
  notifications: any
  setNotifications?: any
  markRead?: any
  newMessage: boolean
}

const defaultState = {
  loading: 'idle',
  notifications: [],
  newMessage: false
}

const NotificationStore = (set: SetState<NotificationState>, get: GetState<NotificationState>) => ({
  ...defaultState,
  setNotifications: async (data: any) => {
    const { notifications } = get()
    try {
      set({ notifications: [data, ...notifications] })
    } catch (error: any) {
      console.log(error)
    }
  },
  markRead: async () => {
    const { notifications } = get()
    set({
      notifications: notifications.map((notification: any) => {
        return { ...notification, read: true }
      }),
      newMessage: false
    })
  },
  setNewMessage: () => {
    set({ newMessage: true })
  }
})

const useNotificationStore = create(
  persist<NotificationState>(NotificationStore, {
    name: 'notification-store'
  })
)

export default useNotificationStore
